import { createAutoAnimatePlugin } from "@formkit/addons";
import { genesisIcons, search } from "@formkit/icons";
import { en, de } from "@formkit/i18n";

import { rootClasses } from "../formkit.theme.mjs";
import { validUserIdpDisplayName } from "./utils/userIdpDisplayName";

const config = {
  // Bundle FormKit icons locally; the default CDN loader (cdn.jsdelivr.net) is
  // blocked by the connect-src CSP. search is used by prefix-icon on the dashboard.
  icons: { ...genesisIcons, search },
  rules: {
    // Named to match the backend's error key so the two stay findable together.
    userIdpDisplayName: (node) => validUserIdpDisplayName(node.value),
  },
  locales: { en, de },
  locale: "en",
  config: {
    rootClasses: (sectionName, node) => {
      // Clone: rootClasses() memoises and returns a shared object per section,
      // so mutating it in place leaks our additions (e.g. the required-asterisk
      // class) onto every other field of that section.
      const classes = { ...rootClasses(sectionName, node) };

      if (sectionName === "label" && node.props?.validation?.includes("required")) {
        classes["after:content-['_*'] after:text-red-500 after:ml-0.5"] = true;
      }

      // The generated theme omits appearance-none on the select input, so the
      // native browser arrow renders on top of FormKit's themed selectIcon.
      if (sectionName === "input" && node.props?.type === "select") {
        classes["appearance-none"] = true;
      }

      return classes;
    },

    // This is only so until formkit gets updated to work properly - https://github.com/formkit/formkit/issues/1623
    sectionsSchema: {
      input: {
        attrs: {
          "aria-invalid": {
            if: "$state.validationVisible",
            then: "$state.invalid",
          },
        },
      },
    },
  },
  plugins: [
    (node) => {
      if (node.props.validation?.includes("required")) {
        node.props["label-class"] = "after:content-[' *']";
      }
    },
    createAutoAnimatePlugin(),
  ],
};

export default config;
